import useLenis from "@/hooks/useLenis";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import BrandMarquee from "@/components/site/BrandMarquee";
import Services from "@/components/site/Services";
import Manifesto from "@/components/site/Manifesto";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useLenis();

  return (
    <div className="bg-[#050505] min-h-screen relative">
      {/* Global noise overlay */}
      <div className="noise-overlay pointer-events-none fixed inset-0 opacity-[0.035] mix-blend-difference z-50" />

      <Nav />
      <main>
        <Hero />
        <BrandMarquee />
        <Services />
        <Manifesto />
        <Gallery />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
